import {NgModule} from '@angular/core';
import {HelpComponent} from "./help";
import {IonicModule} from "ionic-angular";

@NgModule({
  declarations: [
    HelpComponent,
  ],
  exports: [
    HelpComponent
  ],
  imports: [
    IonicModule
  ]
})
export class HelpModule {}



// WEBPACK FOOTER //
// ./src/components/help/help.module.ts